import { FC } from 'react';
import { Card, Body1Strong, Body1, Subtitle2, Body2 } from '@fluentui/react-components';

import { TResolvedSubmissionItem, TSubmission } from '../../../types/submissions.types';
import { TResolvedItemsMap } from '@modules/items';
import { HalfDonutChart } from '@shared/components/HalfDonutChart';
import getSubmissionStats from '@modules/submissions/helpers/getSubmissionStats.helper';

type TProps = {
  resolvedSelectedItems: TResolvedSubmissionItem[];
};

const SubmissionReadinessCard = ({ resolvedSelectedItems }: TProps) => {
  const { totalCount, acceptedCount, progressPct } = getSubmissionStats(resolvedSelectedItems);

  const todoCount = totalCount - acceptedCount;

  const formatPlural = (count: number) => (count === 1 ? '' : 's');

  return (
    <Card className="flex flex-col w-[333px]" size="large">
      <Subtitle2>Progress</Subtitle2>

      <div>
        <div className="flex justify-between">
          <Body1Strong className="text-brand-80">
            {acceptedCount} file{formatPlural(acceptedCount)} accepted
          </Body1Strong>
          <Body1 className="text-neutralFg-4">
            {todoCount} file{formatPlural(todoCount)} todo
          </Body1>
        </div>

        <HalfDonutChart percent={progressPct} />

        {/* Footer: total */}
        <div className="flex w-full justify-center pt-3">
          <Body1>
            {totalCount} file{formatPlural(totalCount)} in total
          </Body1>
        </div>
      </div>
    </Card>
  );
};

export default SubmissionReadinessCard;
